var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExtensions = function SvgExtensions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.084 0a6.375 6.375 0 0 1 1.04 12.664 6.375 6.375 0 1 1-7.33-7.329A6.376 6.376 0 0 1 12.084 0M5.787 7.376A4.377 4.377 0 0 0 6.834 16a4.376 4.376 0 0 0 4.248-3.33 6.38 6.38 0 0 1-5.295-5.294m2.035-.013a4.38 4.38 0 0 0 3.273 3.273 4.38 4.38 0 0 0-3.273-3.273M12.084 2a4.38 4.38 0 0 0-4.249 3.328 6.38 6.38 0 0 1 5.295 5.295A4.376 4.376 0 0 0 12.084 2",
    clipRule: "evenodd"
  })));
};
export default SvgExtensions;